var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "academy-common-lib": "static-1.13703"
    },
    "depPathPrefixes": {
      "academy-common-lib": "/academy-common-lib/static-1.13703"
    },
    "bundlingPackage": "LearningCenterUI",
    "bundlingPackageVersion": "static-1.33300",
    "project": "academy-common-lib",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};